<template>
    <div class="flex-sb">
        <el-form ref="form" :model="form" label-width="180px">
          
            <el-form-item label="学生名称">
                <el-input v-model="form.title" placeholder="（用来标注签署的谁的文件）"></el-input>
            </el-form-item>

            <el-form-item label="选择要签署的文件">
                <el-checkbox-group v-model="form.tag">
                    <el-checkbox label="1" name="type">寄宿家庭项目协议</el-checkbox>
                    <el-checkbox label="2" name="type">监护人授权和医药授权同意书</el-checkbox>
                    <el-checkbox label="3" name="type">授权成绩单账户查询</el-checkbox>
                    <el-checkbox label="4" name="type">外出知情及免责声明</el-checkbox>
                    <el-checkbox label="5" name="type">独自乘坐飞机授权</el-checkbox>
                    <el-checkbox label="6" name="type">入学文件确认页</el-checkbox>
                </el-checkbox-group>
            </el-form-item>

            <el-form-item v-if="form.tag.includes('1')" label="寄宿家庭协议版本">
                <el-radio-group v-model="form.type">
                    <el-radio :label="1">C端</el-radio>
                    <el-radio :label="2">B端</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="onSubmit">立即创建合同</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { Generated } from "@/api/home"
export default {
    data() {
        return {
            form: {
                tag: [],
                title:"",
                type: 2
            }
        }
    },
    methods: {
        onSubmit() {
            const baseUrl = window.location.origin;
            if(!this.form.title){
                this.$message({
                    message: '填一下文件的当事人名称',
                    type: 'warning'
                });
                return
            }
            if (this.form.tag.length == 0) {
                this.$message({
                    message: '没选合同，怎么生成呢？？',
                    type: 'warning'
                });
                return
            }
            Generated({
                tag: this.form.tag,
                title: this.form.title,
                type: this.form.type
            }).then(res => {
                if (res.code == 200) {
                    this.$message({
                        message: '合同生成成功',
                        type: 'success'
                    });


                    this.$router.push('/leave' + `?id=${res.data.id}`);
                }
            });

        }
    },
}
</script>

<style lang="scss" scoped>
.flex-sb {
    width: 100%;
    margin: 40px auto;

    a {
        color: #fff;
    }
}
</style>
